/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_ReposInputs */



/**
* | output |
* | --- |
* | "repos" |
*
* @param {Metrics_ReposInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_repos = /** @type {((inputs?: Metrics_ReposInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_ReposInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("repos")
});